import { OptionCard } from './OptionCard'
import { OptionsGrid } from './styles/OptionCardStyles'
import { QuestionTitle } from './styles/SignUpFlowStyles'
import { PARTNER_AUDIENCE_SIZE } from '../../constants/partnerSurveyOptions'

interface PartnerSurveyStepAudienceProps {
  value: string | null
  onChange: (value: string) => void
}

export function PartnerSurveyStepAudience({ value, onChange }: PartnerSurveyStepAudienceProps) {
  return (
    <div>
      <QuestionTitle>What's the size of your audience?</QuestionTitle>
      <OptionsGrid>
        {PARTNER_AUDIENCE_SIZE.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            isSelected={value === option.value}
            onClick={() => onChange(option.value)}
            isMultiSelect={false}
          />
        ))}
      </OptionsGrid>
    </div>
  )
}
